export const getAdsManagerStepStyle = () => ({
  container: {
    '& .ad-thumbnail': {
      padding: '0px',
    },
  },
});

